import "@fontsource-variable/plus-jakarta-sans/wght.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter } from "react-router";
import { App } from "./App";
import { followHostClub } from "./app/host-club";
import { createBrowserServices } from "./app/services";
import { buildRoutes } from "./routes";
import { applyInitialTheme } from "./theme/ThemeProvider";
import "@clubcore/ui/tokens.css";
import "@clubcore/ui/base.css";
import "./ui/ui.css";
import "./app/shell.css";

applyInitialTheme();
const services = createBrowserServices();
// On a club's own domain the server names the club (and a portal-only domain sends the browser to the portal) before sign-in.
void fetch(`${import.meta.env.VITE_API_BASE_URL ?? "/api/v1"}/system/health`)
  .then((response) => followHostClub(response.headers, services.clubSelection))
  .catch(() => undefined);
const router = createBrowserRouter(buildRoutes(), { basename: import.meta.env.BASE_URL.replace(/\/$/, "") || undefined });

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App services={services} router={router} />
  </StrictMode>,
);
